module.exports = __webpack_public_path__ + "assets/68bc9655cd4c81fe6d1684d1f645542d.png";